import { ViewStyle } from 'react-native'
import { Svg, Path } from 'react-native-svg'
import { themed } from './themed'
import { ColorTokens, ThemeTokens } from '@tamagui/core'

export type QuotesIconProps = {
  /**
   * This is for the width. Height is computed for you.
   */
  size?: number
  color?: (ColorTokens | ThemeTokens) | null
  style?: ViewStyle
}

/**
 * When size is given, it is talking about width. We compute the height from the viewbox ratio
 * because it needs both width and height to be universal.
 */
const computeHeight = (size: number) => {
  return size * (23 / 16)
}

export const QuotesIconComponent = ({
  style,
  color: colorProp,
  size = 24,
}: QuotesIconProps) => {
  const color = colorProp ?? 'black'
  const computedHeight = computeHeight(size)

  return (
    <Svg width={size} height={computedHeight} viewBox="0 0 23 16" fill="none">
      <Path
        d="M22.2987 0V4.17162H20.9257C19.7992 4.20682 18.9896 4.50605 18.4967 5.06931C18.0391 5.63256 17.8102 6.38944 17.8102 7.33993V8.87129H21.8234V16H13.1106V6.9703C13.1106 4.68207 13.709 2.95709 14.9059 1.79538C16.1029 0.633663 17.7046 0.0352031 19.7112 0H22.2987ZM9.88944 0V4.17162H8.51651C7.38999 4.20682 6.58031 4.50605 6.08746 5.06931C5.62982 5.63256 5.40099 6.38944 5.40099 7.33993V8.87129H9.4142V16H0.701324V6.9703C0.701324 4.68207 1.29978 2.95709 2.4967 1.79538C3.69362 0.633663 5.29538 0.0352031 7.30199 0H9.88944Z"
        fill={color}
      />
    </Svg>
  )
}

export const QuotesIcon = themed(QuotesIconComponent)
